/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/scissors_medium'
export default icon
